import { StyleSheet } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  container: (isSelected, theme) => ({
    backgroundColor: isSelected ? Colors.ocean : theme.colors.cardBackgroundColor,
    margin: 6,
    paddingTop: 6,
    paddingBottom: 8,
    paddingHorizontal: 12,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
  }),
})

export default styles
